import React from 'react';
import {Car} from "lucide-react";
import Image1 from "../images/Images1.png";
import Image2 from "../images/Images2.png";
import Image3 from "../images/Images3.png";
import Image4 from "../images/Images4.png";
import Image5 from "../images/Images5.png";
import Image6 from "../images/Images6.png";

const services = [
    {
        title: "Car Lockout Assistance",
        image: Image1
    },
    {
        title: "Key Replacement",
        image: Image2
    },
    {
        title: "Key Programming",
        image: Image3
    },
    {
        title: "Broken Key Extraction",
        image: Image4
    },
    {
        title: "Emergency Locksmith",
        image: Image5
    },
    {
        title: "Mobile Mechanic Service",
        image: Image6
    }
];
const additionalServices = [
    "Radiator replacement",
    "Water pumps",
    "Alternators",
    "Power steering pumps",
    "Fuel pumps",
    "Tune ups",
    "Suspension",
    "Steering components",
    "AC system checks and replacements",
    "Brakes",
    "Scantool diagnostics",
    "Vehicle pre purchase inspections",
    "Towing",
    "Car Key Programming",
    "Dead Battery Replacement"
];

export const Menu = () => {
    return (
        <section className='services-section' id='services'>
            <div className='section-content'>
                <div className='services-header'>
                    <h2 className='section-title'>Our Services</h2>
                    <p className='services-subtitle'>Discover what we can do for you</p>
                </div>
                <div className='services-list-panel'>
                    <ul className='services-list-grid'>
                        {additionalServices.map((service) => (
                            <li key={service} className='services-list-item'>
                                <span className='services-list-badge' aria-hidden='true'>
                                    <Car/>
                                </span>
                                <span>{service}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className='services-grid'>
                    {services.map((service) => (
                        <article
                            key={service.title}
                            className='service-card'
                            aria-label={service.title}
                            style={{backgroundImage: `url(${service.image})`}}
                        >
                            <div className='service-card-overlay'/>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    )
}
